<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-database-plus
        </v-icon>Create Product
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="productName"
                  :rules="[(v) => !!v || 'This field is required']"
                  label=" Product Name*"
                  dense
                  outlined
                  persistent-hint
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="type"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="['bannerEx']"
                  label="Type"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <br>
            <v-textarea
              v-model="productDescription"
              :rules="[(v) => !!v || 'This field is required']"
              filled
              label="Descripion*"
            />
            <br>
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-autocomplete
                  v-model="pricingTier"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="['basic', 'advanced', 'enterprise']"
                  label="Pricing Tier"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-switch
                  v-model="productStatus"
                  class="ma-2 pa-0"
                  label="Status"
                  :persistent-hint="true"
                  color="#FF3700"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createProduct()"
            >
              create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        productName: '',
        showModal: true,
        productDescription: null,
        pricingTier: '',
        productStatus: false,
        loading: false,
        type: '',
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      createProduct () {
        if (this.$refs.form.validate() === true) {
          this.loading = true;
          this.$store.dispatch('payments/createNewProduct', {
            name: this.productName,
            description: this.productDescription,
            active: this.productStatus,
            pricing_plan_type: this.pricingTier,
            type: this.type,
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Product created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$emit('get-product-list');
            this.loading = false;
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
</style>
